import React from "react";
import { Box, Typography } from "@mui/material";
import ImageContainerPreview from "../Common/ImageContainerPreview";
import UniversalLinkField from "../Common/UniversalLinkField";
import SessionAudioComponent from "./SessionAudioComponent";

/**
 * SessionMediaSection renders the "Sharing & Media" section of the session form.
 *
 * Contains a 3-column grid:
 * - Column 1: Deep link image + universal link display
 * - Column 2: Session image preview/upload
 * - Column 3: Session audio preview/upload
 */
const SessionMediaSection = ({
  formData,
  setFormData,
  onImageUpload,
  onDeepLinkImageUpload,
  onMainMediaUpload,
  onAudioLoadedData,
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Sharing & Media
      </Typography>
      <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr" }} gap={4}>
        {/* Column 1: Sharing Settings */}
        <Box display="flex" flexDirection="column" gap={2} alignItems="stretch" sx={{ width: "100%" }}>
          <ImageContainerPreview
            title="Deep Link Image"
            image={formData.session_text_image_url_preview || formData.session_text_image_url}
            name="session_text_image_url"
            handleRemove={() => {
              if (formData.session_text_image_url_preview) {
                URL.revokeObjectURL(formData.session_text_image_url_preview);
              }
              setFormData(prev => ({
                ...prev,
                session_text_image_url: "",
                session_text_image_url_preview: "",
              }));
            }}
            handleImageUpload={onDeepLinkImageUpload}
            showCopyUrlButton={true}
            sx={{
              width: "100%",
              padding: 1,
              background: "#FFFCF5",
              height: 90,
              objectFit: "contain",
              minWidth: 120,
            }}
          />
          <Box display="flex" flexDirection="column" gap={2} flex={1} sx={{ width: "100%" }}>
            <UniversalLinkField url={formData.universal_link} />
          </Box>
        </Box>
        {/* Column 2: Session Image */}
        <Box display="flex" flexDirection="column" gap={2}>
          <ImageContainerPreview
            title="Session Image"
            image={formData.session_image_preview || formData.session_image}
            name="session_image"
            handleRemove={() => {
              if (formData.session_image_preview) {
                URL.revokeObjectURL(formData.session_image_preview);
              }
              setFormData(prev => ({
                ...prev,
                session_image: "",
                session_image_preview: "",
              }));
            }}
            handleImageUpload={onImageUpload}
            showCopyUrlButton={true}
            sx={{ padding: 1, background: "#FFFCF5", height: 90, objectFit: "contain" }}
          />
        </Box>
        {/* Column 3: Session Audio */}
        <Box display="flex" flexDirection="column" gap={2}>
          <SessionAudioComponent
            audio={formData.session_main_url}
            audioPreview={formData.session_main_url_preview}
            onAudioUpload={onMainMediaUpload}
            onAudioLoadedData={onAudioLoadedData}
            onAudioRemove={() => {
              if (formData.session_main_url_preview) {
                URL.revokeObjectURL(formData.session_main_url_preview);
              }
              setFormData(prev => ({
                ...prev,
                session_main_url: "",
                session_main_url_preview: "",
                session_length_in_sec: 0,
              }));
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SessionMediaSection;
